import { useCookie, useRuntimeConfig } from "#app";
import { APIError } from "@meistrari/auth-core";
import { createNuxtAuthClient } from "../shared.js";
import { useOrganizationState, useSessionState } from "./state.js";
export function useTelaSession() {
  const { user, session } = useSessionState();
  const { jwtCookieName, apiUrl } = useRuntimeConfig().public.telaAuth;
  const tokenCookie = useCookie(jwtCookieName);
  const authClient = createNuxtAuthClient(apiUrl, () => tokenCookie.value ?? null);
  async function getSession() {
    return await authClient.session.getSession();
  }
  async function getToken() {
    try {
      const { token } = await authClient.session.getToken();
      return token;
    } catch (error) {
      if (error instanceof APIError && error.status === 401) {
        await signOut();
      }
      return null;
    }
  }
  async function signInWithSocialProvider({
    provider,
    callbackURL,
    errorCallbackURL
  }) {
    await authClient.session.signInWithSocialProvider({
      provider,
      callbackURL,
      errorCallbackURL
    });
  }
  async function signInWithSaml({
    email,
    callbackURL,
    errorCallbackURL
  }) {
    await authClient.session.signInWithSaml({
      email,
      callbackURL,
      errorCallbackURL
    });
  }
  async function signInWithEmailAndPassword({
    email,
    password,
    callbackURL,
    errorCallbackURL
  }) {
    await authClient.session.signInWithEmailAndPassword({
      email,
      password,
      callbackURL,
      errorCallbackURL
    });
  }
  async function requestPasswordReset(email, callbackURL) {
    await authClient.session.requestPasswordReset(email, callbackURL);
  }
  async function resetPassword(token, password) {
    await authClient.session.resetPassword(token, password);
  }
  async function signOut(callback) {
    const { activeOrganization, activeMember } = useOrganizationState();
    await authClient.session.signOut(async () => {
      tokenCookie.value = null;
      user.value = null;
      session.value = null;
      activeOrganization.value = null;
      activeMember.value = null;
      await callback?.();
    });
  }
  return {
    user,
    session,
    getSession,
    getToken,
    signInWithEmailAndPassword,
    signInWithSocialProvider,
    signInWithSaml,
    signOut,
    requestPasswordReset,
    resetPassword
  };
}
